import React from 'react';
import { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../Core/hooks';
//import { createProject } from '../Store/Project';
import { ContextMenu } from '../Models/ContextMenu';
import { UserMentionContextMenuParams } from '../Models/Requests/UserMentionContextMenuParams';
import { AiOutlineClose, AiFillCloseCircle } from "react-icons/ai";
import { BiSearch } from "react-icons/bi";
//import { Member } from '../Models/Requests/Member';
import { getRoadmap } from '../Store/Roadmap';
import { openSocket } from '../Helpers/openSocket';
import { setSocket, getSettings, toggleChatMessages, setInsertUserInComment } from '../Store/Settings';
import { getUser } from '../Store/Auth';
import Avatar from '../Components/Avatar';
import { Member } from '../Models/Requests/Member';
import { getChat, setChannels } from '../Store/Chat';
import { useIsMobile } from '../Core/hooks';

interface Props {
    params: UserMentionContextMenuParams | undefined;    
}

function UserMentionContextMenu(props: Props) {

    const dispatch = useAppDispatch();
    const roadmapState = useAppSelector(getRoadmap);
    const settingsState = useAppSelector(getSettings);
    const userState = useAppSelector(getUser);
    const chatState = useAppSelector(getChat);
    const [name, setName] = useState("");
    const [findMember, setFindMember] = useState("");
    const [chatChannelContextMenu, setChatChannelContextMenu] = useState<ContextMenu>();
    const [findMembers, setFindMembers] = useState<Array<Member>>([]);
    const [channelMembers, setChannelMembers] = useState<Array<Member>>([]);
    const popupRef = useRef<HTMLDivElement>(null);
    const isMobile = useIsMobile();
    /*
    useEffect(() => {
        const handleClickOutside = (e: MouseEvent) => {
          if (popupRef.current && popupRef.current === e.target) {
            closeContextMenu(); // Close if clicked outside
          }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
*/
    useEffect(() => {
        setFindMembers(chatState.findMembers);
    }, [chatState.findMembers]);
    
    useEffect(() => {
        if (props.params) {
            //clearState();
            let contextMenu = { _id: "", x: 0, y: 0, width: 0, height: 0 };
            if ((chatChannelContextMenu && chatChannelContextMenu._id !== props.params._id) || !chatChannelContextMenu) {
                let menuWidth = 300;
                let menuXStart = props.params.x + 300;
                let menuYStart = props.params.y;
                //let menuYStart = window.scrollY + (window.innerHeight / 2) - 100;
                /*
                if (menuXStart > window.outerWidth) {
                    menuXStart = window.outerWidth - 10;
                }
                    */
                contextMenu._id = props.params._id;
                contextMenu.x = menuXStart;
                contextMenu.y = menuYStart;
                contextMenu.width = menuWidth;
                setChatChannelContextMenu(contextMenu);
            }

            /*
            clearState();
            let contextMenu = { _id: "", x: 0, y: 0, width: 0, height: 0 };
            if ((chatChannelContextMenu && chatChannelContextMenu._id !== props.params._id) || !chatChannelContextMenu) {
                let menuWidth = 300;
                let menuXStart = props.params.x + 30;
                let menuYStart = props.params.y - 35;
                if (menuXStart > window.outerWidth) {
                    menuXStart = window.outerWidth - 10;
                }
                contextMenu._id = props.params._id;
                contextMenu.x = menuXStart;
                contextMenu.y = menuYStart;
                contextMenu.width = menuWidth;
            }
            setChatChannelContextMenu(contextMenu);
            */
        }
    }, [props.params]);

    const clearState = () => {
        setName("");
        setFindMember("");
        setFindMembers([]);
        setChannelMembers([]);
    }

    const closeContextMenu = (e?: React.MouseEvent<HTMLAnchorElement> | React.MouseEvent<HTMLDivElement>) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        clearState();
        let contextMenu = { _id: "", x: 0, y: 0, width: 0, height: 0 };
        setChatChannelContextMenu(contextMenu);
    }
    /*
    const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setName(e.currentTarget.value)
    }

    const handleFindMemberChange = (e: React.ChangeEvent<HTMLInputElement>) => {        
        setFindMember(e.currentTarget.value);
        let socket = openSocket(dispatch, settingsState);
        if (socket) {
            socket.emit("getMembers", { 
                name: e.currentTarget.value 
            });
        }
    }

    const handleCreateChannel = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        e.stopPropagation();
        let socket = openSocket(dispatch, settingsState);
        if (socket) {
            socket.emit("createChannel", { 
                name: name,
                members: channelMembers
            });
            // expand chat on add
            if (props.params?._id !== '1') {
                dispatch(toggleChatMessages(true));
            }

            closeContextMenu();
        }
    }

    const addMemberToChannel = (e: React.MouseEvent<HTMLDivElement>, member: Member) => {
        e.preventDefault();
        e.stopPropagation();
        let tempMembers = [...channelMembers];
        tempMembers.push(member);
        setChannelMembers(tempMembers);
    }

    const removeChannelMember = (e: React.MouseEvent<HTMLDivElement>, member: Member) => {
        e.preventDefault();
        e.stopPropagation();
        let tempMembers = [...channelMembers];

        let index = channelMembers.findIndex(m => m.email === member.email);
        if (index !== -1) {
            tempMembers.splice(index, 1);
            setChannelMembers(tempMembers);
        }        
    }
``  */
    const chooseUser = (e: React.MouseEvent<HTMLDivElement>, member: Member) => {
        e.preventDefault();
        e.stopPropagation();
        //let users = [...settingsState.usersInComment];
        dispatch(setInsertUserInComment(member));
        closeContextMenu();
        /* Left off here 6/8/25. We now need to figure out how to insert this member back
           into the Quill Editor of the comment. Then, once we figure that out, we will have
           to implement either creating a chat channel to the inserted user and creating a
           chat with the comment text OR locate the existing chat and insert the comment
           as a chat.
        */
        //let tempMembers = [...channelMembers];
        //tempMembers.push(member);
        //setChannelMembers(tempMembers);
    }
    /*
    const sContextMenu: React.CSSProperties = {
        top: (chatChannelContextMenu) ? chatChannelContextMenu.y : 0,
        left: (chatChannelContextMenu) ? chatChannelContextMenu.x : 0,
        width: (chatChannelContextMenu) ? chatChannelContextMenu.width : 3000,
        height: "auto",
        paddingBottom: "15px",
    }
    */
    const sContextMenu: React.CSSProperties = {
        top: chatChannelContextMenu && !isMobile ? chatChannelContextMenu.y : 150,
        left: chatChannelContextMenu && !isMobile ? chatChannelContextMenu.x : 0,
        width: isMobile 
            ? "80vw" 
            : chatChannelContextMenu
                ? chatChannelContextMenu.width 
                : 300,
        height: isMobile ? "20vh" : "auto",
        paddingBottom: "15px",
    };

    //console.log(props.params?.text.substring(1));
    let searchText = (props.params?.text) ? props.params.text.toLowerCase().substring(1) : "";
    let members = roadmapState.members.filter(m => m.status !== "invited" && 
        m.firstName.toLowerCase().startsWith(searchText) && searchText !== "" && !m.me);

    //console.log(members);

    let formattedMembers = members.map((member, index) => {
        return (
            <div key={index} className="memberList" onClick={(e) => chooseUser(e, member)}>
                <div style={{ width: "15%", display: "inline-block", padding: "2px" }}>
                    <Avatar size="small" member={member} />
                </div>
                <div style={{ width: "65%", display: "inline-block", textAlign: "left", padding: "2px" }}>
                    {member.firstName} {member.lastName}
                </div>                
            </div>
        );
    })


//{roadmapState.members.filter(m => m.userId !== userState._id).length > 0 ?
    return (
        <>
        {chatChannelContextMenu && chatChannelContextMenu._id !== "" &&
            <div ref={popupRef} className="popupContainer">
                <div className="contextMenu" style={sContextMenu}>
                    <h1 style={{ marginBottom: "0px" }}>
                        Locate Member
                    </h1>
                    <div className="divClose">
                        <Link to="" onClick={(e) => closeContextMenu(e)}>
                            <AiOutlineClose color="#555" size="13" />
                        </Link>
                    </div>
                    <div style={{ textAlign: "center", paddingTop: "10px" }}>
                        <div style={{ padding: "0px 10px" }}>
                            {formattedMembers.length === 0 ?
                                <div style={{ textAlign: "center", paddingBottom: "10px", fontStyle: "italic", fontSize: "10pt" }}>
                                    Type to locate members
                                </div>
                            :
                                <>{formattedMembers}</>
                            }
                        </div>
                        {/*
                        <div style={{ marginTop: "13px", textAlign: "left" }}>
                            <Link to="" onClick={(e) => handleCreateChannel(e)} className="btn-orange">
                                Create
                            </Link> 
                        </div>
                        */}
                    </div>
                </div>
            </div>
        }
        </>
    );
}

export default UserMentionContextMenu;